import {Injectable} from '@angular/core';

export interface MainMenuItems {
  state: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS_ADMIN = [
	{
		label: 'data_administration.menu_links.import',
		main: [
			{
				state: 'dashboard',
				name: 'data_administration.menu_links.dashboard',
				type: 'link',
				target: false,
			},
			{
				state: 'import/history',
				name: 'import.history',
				type: 'link',
				target: false,
			},
			{
				state: 'import/profiles',
				name: 'import.profile.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'import/profiletemplates',
				name: 'import.profileTemplate.plural',
				type: 'link',
				target: false,
			}
		]
	},
	{
		label: 'data_administration.menu_links.articles',
		main: [
			{
				state: 'data-administration/articles',
				name: 'data_administration.entities.article.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/supplierarticlevariants',
				name: 'data_administration.entities.supplierArticleVariant.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/customerarticles',
				name: 'data_administration.entities.customerArticle.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/groupings',
				name: 'data_administration.entities.grouping.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/packagings',
				name: 'data_administration.entities.packaging.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/packagingcontainers',
				name: 'data_administration.entities.packagingContainer.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/units',
				name: 'data_administration.entities.unit.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/baseunits',
				name: 'data_administration.entities.baseUnit.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/resources',
				name: 'data_administration.entities.resource.plural',
				type: 'link',
				target: false,
			}
		]
	},
	{
		label: 'data_administration.menu_links.companies',
		main: [
			{
				state: 'data-administration/companies',
				name: 'data_administration.entities.company.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/locations',
				name: 'data_administration.entities.location.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/customersuppliers',
				name: 'data_administration.entities.customerSupplier.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/companygroups',
				name: 'data_administration.entities.companyGroup.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/companynetworks',
				name: 'data_administration.entities.companyNetwork.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/users',
				name: 'data_administration.entities.user.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/permissions',
				name: 'data_administration.entities.permission.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/companycertificates',
				name: 'data_administration.entities.companyCertificate.plural',
				type: 'link',
				target: false,
			},
		]
	},
	{
		label: 'data_administration.menu_links.notification_center',
		main: [
			{
				state: 'data-administration/news',
				name: 'data_administration.entities.news.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/notifications',
				name: 'data_administration.entities.notification.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/surveys',
				name: 'data_administration.entities.survey.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/tutorials',
				name: 'data_administration.entities.tutorial.plural',
				type: 'link',
				target: false,
			}
		]
	},
	{
		label: 'data_administration.menu_links.miscellaneous',
		main: [
			{
				state: 'data-administration/countries',
				name: 'data_administration.entities.country.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/taxrates',
				name: 'data_administration.entities.taxRate.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/characteristics',
				name: 'data_administration.entities.characteristic.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/certificates',
				name: 'data_administration.entities.certificate.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/analystvaluations',
				name: 'data_administration.entities.analystValuation.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/sectors',
				name: 'data_administration.entities.sector.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/subscriptions',
				name: 'data_administration.entities.subscription.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/companysubscriptions',
				name: 'data_administration.entities.companySubscription.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/legaldocuments',
				name: 'data_administration.entities.legalDocument.plural',
				type: 'link',
				target: false,
			}
		]
	},
	{
		label: 'data_administration.menu_links.protocols',
		main: [
			{
				state: 'data-administration/companies/importfiles',
				name: 'data_administration.entities.file.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/faultylogins',
				name: 'data_administration.entities.faultyLogin.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/trackings/news',
				name: 'data_administration.entities.tracking.news',
				type: 'link',
				target: false,
			}
			,
			{
				state: 'data-administration/trackings/suppliers',
				name: 'data_administration.entities.tracking.suppliers',
				type: 'link',
				target: false,
			}
			,
			{
				state: 'data-administration/trackings/supplierarticlevariants',
				name: 'data_administration.entities.tracking.supplierarticlevariants',
				type: 'link',
				target: false,
			}
			,
			{
				state: 'data-administration/trackings/tutorials',
				name: 'data_administration.entities.tracking.tutorials',
				type: 'link',
				target: false,
			}
		]
	}
];

const MENUITEMS_DATA_ADMIN = [
	{
		label: 'data_administration.menu_links.import',
		main: [
			{
				state: 'dashboard',
				name: 'Dashboard',
				type: 'link',
				target: false,
			}
		]
	},
	{
		label: 'data_administration.menu_links.articles',
		main: [
			{
				state: 'data-administration/articles',
				name: 'data_administration.entities.article.plural',
				type: 'link',
				target: false,
			},
		{
			state: 'data-administration/supplierarticlevariants',
			name: 'data_administration.entities.supplierArticleVariant.plural',
			type: 'link',
			target: false,
		},
		{
			state: 'data-administration/groupings',
			name: 'data_administration.entities.grouping.plural',
			type: 'link',
			target: false,
		},
		{
			state: 'data-administration/packagings',
			name: 'data_administration.entities.packaging.plural',
			type: 'link',
			target: false,
		},
		{
			state: 'data-administration/packagingcontainers',
			name: 'data_administration.entities.packagingContainer.plural',
			type: 'link',
			target: false,
		},
		{
			state: 'data-administration/units',
			name: 'data_administration.entities.unit.plural',
			type: 'link',
			target: false,
		},
		{
			state: 'data-administration/baseunits',
			name: 'data_administration.entities.baseUnit.plural',
			type: 'link',
			target: false,
		},
		{
			state: 'data-administration/resources',
			name: 'data_administration.entities.resource.plural',
			type: 'link',
			target: false,
		}]
	},
	{
		label: 'data_administration.menu_links.companies',
		main: [
			{
				state: 'data-administration/companies',
				name: 'data_administration.entities.company.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/locations',
				name: 'data_administration.entities.location.plural',
				type: 'link',
				target: false
			},
			{
				state: 'data-administration/companycertificates',
				name: 'data_administration.entities.companyCertificate.plural',
				type: 'link',
				target: false,
			},
		]
	},
	{
		label: 'data_administration.menu_links.notification_center',
		main: [
			{
				state: 'data-administration/news',
				name: 'data_administration.entities.news.plural',
				type: 'link',
				target: false,
			}
		]
	},
	{
		label: 'data_administration.menu_links.miscellaneous',
		main: [
			{
				state: 'data-administration/countries',
				name: 'data_administration.entities.country.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/taxrates',
				name: 'data_administration.entities.taxRate.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/characteristics',
				name: 'data_administration.entities.characteristic.plural',
				type: 'link',
				target: false,
			},
			{
				state: 'data-administration/certificates',
				name: 'data_administration.entities.certificate.plural',
				type: 'link',
				target: false,
			}
		]
	},
	{
		label: 'data_administration.menu_links.protocols',
		main: [
			{
				state: 'data-administration/companies/importfiles',
				name: 'data_administration.entities.file.plural',
				type: 'link',
				target: false,
			},
		]
	}
];

@Injectable()
export class MenuItems {
  getAdminItems(): Menu[] {
    return MENUITEMS_ADMIN;
  }
  getDataAdminItems(): Menu[] {
	  return MENUITEMS_DATA_ADMIN;
  }
}
